import React, { useState, useEffect, useRef } from 'react';

const Hero = ({ translations }) => {
    const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
    const [isHovering, setIsHovering] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const handleMouseMove = (e) => {
            if (sectionRef.current) {
                const rect = sectionRef.current.getBoundingClientRect();
                setMousePosition({
                    x: e.clientX - rect.left,
                    y: e.clientY - rect.top
                });
            }
        };

        const section = sectionRef.current;
        if (section) {
            section.addEventListener('mousemove', handleMouseMove);
            section.addEventListener('mouseenter', () => setIsHovering(true));
            section.addEventListener('mouseleave', () => setIsHovering(false));
        }

        return () => {
            if (section) {
                section.removeEventListener('mousemove', handleMouseMove);
                section.removeEventListener('mouseenter', () => setIsHovering(true));
                section.removeEventListener('mouseleave', () => setIsHovering(false));
            }
        };
    }, []);

    return (
        <section
            ref={sectionRef}
            id="hero"
            className="min-h-screen flex items-center justify-center relative overflow-hidden pt-20"
        >

            <div className="absolute inset-0 bg-gradient-to-b from-black to-dark-bg"></div>
            <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-neon-red/10 rounded-full blur-3xl"></div>
            <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-neon-red/5 rounded-full blur-3xl"></div>

            {/* Cursor-following glow effect */}
            <div
                className="absolute pointer-events-none transition-opacity duration-300"
                style={{
                    left: mousePosition.x - 250,
                    top: mousePosition.y - 250,
                    width: 500,
                    height: 500,
                    background: 'radial-gradient(circle, rgba(255, 0, 0, 0.18) 0%, rgba(255, 0, 0, 0.08) 40%, transparent 70%)',
                    borderRadius: '50%',
                    filter: 'blur(50px)',
                    opacity: isHovering ? 1 : 0,
                }}
            />

            <div className="section-container text-center relative z-10">
                <h1 className="text-7xl md:text-9xl font-bold mb-6 heading-gradient animate-pulse">
                    {translations.hero.title}
                </h1>

                <h2 className="text-2xl md:text-3xl font-semibold mb-6 text-gray-200">
                    {translations.hero.subtitle}
                </h2>

                <p className="text-xl text-gray-400 max-w-3xl mx-auto mb-12">
                    {translations.hero.description}
                </p>

                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <button
                        onClick={() => document.getElementById('action').scrollIntoView({ behavior: 'smooth' })}
                        className="px-8 py-4 bg-neon-red text-black font-bold rounded-lg text-lg hover:bg-neon-red-dark transition-colors neon-glow"
                    >
                        {translations.action.email_button}
                    </button>

                    <button
                        onClick={() => document.getElementById('problems').scrollIntoView({ behavior: 'smooth' })}
                        className="px-8 py-4 border-2 border-neon-red text-neon-red font-bold rounded-lg text-lg hover:bg-neon-red/10 transition-colors"
                    >
                        {translations.nav.problems}
                    </button>
                </div>
            </div>

            
            <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
                <svg className="w-6 h-6 text-neon-red" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                </svg>
            </div>
        </section>
    );
};

export default Hero;